import { Pipe, PipeTransform } from '@angular/core';
import { InstallationCommentsPluginService } from './installation-comments.service';
@Pipe({
    name: 'commentto',
    standalone: false
})
export class CommentToPipe implements PipeTransform {
  public points: any[];
  constructor(private service: InstallationCommentsPluginService) {
    this.points = this.service.getCommentToTargets();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.points);
  }
}
